import React from 'react';
import { Box, Button, Grid } from '@mui/material';
import { SelectOption } from '../../../modules/shared/model';
import FormInput from '../../../modules/shared/form/FormInput';
import SelectInput from '../../../modules/shared/form/SelectInput';
import { RecipeIntegrationsAutoTreatContext } from '../contexts/RecipeIntegrationsAutoTreatContext';
import { AuthContext } from '../../../modules/auth/contexts/AuthContext';

interface IntegrationFormProps {
  liquidRecipeId: any;
  recipeIntegration: any;
  setShowIntegrationForm: any;
  machineSerial: any;
  partnerChoices: SelectOption[];
}

const IntegrationForm: React.FC<IntegrationFormProps> = (props) => {
  const { recipeIntegration, setShowIntegrationForm, machineSerial, partnerChoices, liquidRecipeId } = props;

  const { currentUserHasUserPermission } = React.useContext(AuthContext);

  const {
    updateRecipeIntegrationAutoTreat,
    createRecipeIntegrationAutoTreat,
    deleteRecipeIntegrationAutoTreat,
    recipeIntegrationsSubmitting,
  } = React.useContext(RecipeIntegrationsAutoTreatContext);

  const [formValues, setFormValues] = React.useState<any>({});
  const [initialLoad, setInitialLoad] = React.useState(false);

  React.useEffect(() => {
    if (!initialLoad) {
      setInitialLoad(true);

      setFormValues({
        integration_id: recipeIntegration?.integration_id,
        liquid_recipe_id: recipeIntegration?.liquid_recipe_id || liquidRecipeId,
        api_partner: recipeIntegration?.api_partner,
        partner_record_id_1: recipeIntegration?.partner_record_id_1,
        partner_record_id_2: recipeIntegration?.partner_record_id_2,
        partner_record_id_3: recipeIntegration?.partner_record_id_3,
      });
    }
  }, []);

  const handleUpdate = () => {
    updateRecipeIntegrationAutoTreat(
      machineSerial,
      recipeIntegration.liquid_recipe_id,
      recipeIntegration?.integration_id,
      formValues,
    );
  };

  const handleCreate = () => {
    createRecipeIntegrationAutoTreat(machineSerial, formValues.liquid_recipe_id, formValues);
  };

  const handleDelete = () => {
    setShowIntegrationForm(false);
    deleteRecipeIntegrationAutoTreat(machineSerial, formValues.liquid_recipe_id, formValues.integration_id);
  };

  const handleBack = () => {
    setShowIntegrationForm(false);
  };

  return (
    partnerChoices && (
      <Box style={{ padding: 0 }}>
        <Grid container alignItems="flex-start" spacing={3}>
          <Grid item xs={8} md={12}>
            <form noValidate autoComplete="off">
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} md={8}>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <SelectInput
                        choices={partnerChoices}
                        value={formValues?.api_partner}
                        onChange={(value) => setFormValues({ ...formValues, api_partner: value })}
                        label="API Partner"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FormInput
                        value={formValues?.partner_record_id_1}
                        onChange={(value) => setFormValues({ ...formValues, partner_record_id_1: value })}
                        label="Partner Record ID 1"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FormInput
                        value={formValues?.partner_record_id_2}
                        onChange={(value) => setFormValues({ ...formValues, partner_record_id_2: value })}
                        label="Partner Record ID 2"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FormInput
                        value={formValues?.partner_record_id_3}
                        onChange={(value) => setFormValues({ ...formValues, partner_record_id_3: value })}
                        label="Partner Record ID 3"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {formValues.integration_id && (
                  <Grid item xs={4} style={{ display: 'flex', justifyContent: 'right', marginTop: '-90px' }}>
                    <Button variant="contained" color="primary" onClick={handleDelete}>
                      Delete
                    </Button>
                  </Grid>
                )}
              </Grid>
              <br />
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  {recipeIntegration?.integration_id ? (
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={
                        recipeIntegrationsSubmitting || !formValues.api_partner || !formValues.partner_record_id_1
                      }
                      onClick={handleUpdate}
                    >
                      {recipeIntegrationsSubmitting ? 'Updating Recipe Integration...' : 'Update Recipe Integration'}
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={
                        recipeIntegrationsSubmitting || !formValues.api_partner || !formValues.partner_record_id_1
                      }
                      onClick={handleCreate}
                    >
                      {recipeIntegrationsSubmitting ? 'Creating Recipe Integration...' : 'Create Recipe Integration'}
                    </Button>
                  )}
                  <Button variant="outlined" style={{ marginLeft: 7 }} onClick={handleBack}>
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Box>
    )
  );
};

export default IntegrationForm;

// const { currentUserHasUserPermission } = React.useContext(AuthContext);

// {currentUserHasUserPermission('company_super_admin')
